module.exports = __webpack_public_path__ + "img/filter.b9cedf09.svg";